/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



//////////////////
// WEBPACK FOOTER
// ./~/is-observable/~/symbol-observable/index.js
// module id = 13
// module chunks = 0